<div class="d-flex gap-2 flex-wrap">
    <div class="d-flex align-items-center">
        <div
            class="d-inline-flex gap-1 align-items-center ms-3 cursor-pointer"
            (click)="onContainerClick($event, true)"
        >
            <p-radioButton
                [value]="true"
                [ngModel]="value"
                (ngModelChange)="onCheck($event); onTouchedFn?.()"
                [name]="'order-number-per-treatment-type-select-' + uid"
            />
            <span>首单/第二单</span>
        </div>
    </div>

    <div class="d-flex align-items-center">
        <div
            class="d-inline-flex gap-1 align-items-center ms-3 cursor-pointer"
            (click)="onContainerClick($event, null)"
        >
            <p-radioButton
                [value]="null"
                [ngModel]="value"
                (ngModelChange)="onCheck($event); onTouchedFn?.()"
                [name]="'order-number-per-treatment-type-select-' + uid"
            />
            <span>无</span>
        </div>
    </div>
</div>
